<template>
  <div class="partners">
    <div class="container">
      <div class="container__liner">
        <div id="navigation">
          <div class="breadcrumbs">
            <a itemprop="itemListElement" href="/" class="breadcrumbs-item">Главная</a>
            <span class="breadcrumbs-item">Партнерам</span>
          </div>
        </div>

        <div class="title">
          <h1 id="pagetitle" class="entry">
            <span>{{ pageH1 }}</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="container ">
      <div class="container__liner">
        <div class="entry">
          <div class="entry__content">
            <p style="text-align: center;"><span style="color:#000000;"><span style="font-size:22px; font-weight:900">
              <b>Компания Uniqom - эксклюзивный дистрибьютор продукции TCL</b></span></span>
            </p>
            <p style="text-align:center"><img alt="" height="534" :src="partner1" width="800" /></p>
            <p>Нашим приоритетом является работа с клиентами напрямую, поэтому мы открыты и приветствуем новые деловые контакты. 
              Компания Uniqom - эксклюзивный дистрибьютор продукции марки TCL в России работает на рынке уже более 15 лет 
              и зарекомендовала себя как надежный поставщик качественных автомобильных товаров. 
              Поставка товаров осуществляется напрямую от производителя марки TCL компании Tanikawa Yuka Kogyo, тем самым, 
              работая с нами, Вы получаете наиболее выгодные условия.
            </p>
            <p style="text-align:center"><img alt="" height="533" :src="partner2" width="800" /></p>
            <p>Широкая филиальная сеть позволит Вам взаимодействовать с филиалом именно в том городе, где это будет наиболее удобно для Вас. 
              Среди наших клиентов &ndash; крупные коммерческие компании и государственные структуры. 
              Вместе мы работаем над тем, чтобы материалы и комплектующие для автомобилей стали качественнее и доступнее.
            </p>
          </div>
        </div>
        <div class="request">
          <div>
            <div class="title">
              <h2>
                <span>Стать партнером компании TCL</span>
              </h2>
            </div>

            <Feedback :partner="true" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Feedback from "../components/Feedback";
import utils from '../utils';
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'
import partner1 from '../assets/img/partner-1.8cbeb2c5.jpg'
import partner2 from '../assets/img/partner-2.7106e78c.jpg'

export default {
  components: {
    Feedback
  },
  data() {
    return {
      content: null,
      partner1,
      partner2,
    }
  },
  computed: {
    pageH1() {
      const s = this.$store.state.seoPage
      if (s && s.id && s.h1) {
        return s.h1
      }
      return 'Как стать партнером TCL'
    },
  },
  methods: {
    async getInitContentPage() {
      const { fetchData } = utils()
      this.content = await fetchData('get', 'content/partners')
    }
  },
  beforeMount() {
     this.getInitContentPage();
  },
  metaInfo() {
    return metaFromSeoOrDefaults(this.$store, {
      title: 'Партнерам',
    })
  },
}
</script>